// RunLiveCard - Pipeline-Live-Ansicht mit pl-mini-Stufen, Job-Steps
// und Success-Burst. Wird aus Scene5 gerendert.

import React, { useEffect, useRef } from "react";
import { useLang } from "../i18n";
import { Cx } from "./IconSprite";

export default function RunLiveCard({ stages, tgtIdx, runInfo, jobs, runNumber, runStatus, runMeta, done, doneText, doneSub }) {
  const { t } = useLang();
  const burstRef = useRef(null);

  useEffect(() => {
    if (done && burstRef.current) {
      burstRef.current.classList.remove("go");
      void burstRef.current.offsetWidth;
      burstRef.current.classList.add("go");
    }
  }, [done]);

  const statusCls = runStatus === "success" ? "st st--ok" : runStatus === "failed" ? "st st--crit" : "st st--info st--pulse";
  const statusTxt = runStatus === "success" ? t("run.ok") : runStatus === "failed" ? t("run.failed") : t("run.running");

  return (
    <div className="run-card">
      <div className="run-head">
        <svg className="ic ic-20" style={{ color: "var(--t3)" }}><use href="#ic-git" /></svg>
        <span className="run-num">{runNumber ? `Run #${runNumber}` : "Run"}</span>
        {runMeta && <span className="run-meta">{runMeta}</span>}
        <span className={statusCls} style={{ marginLeft: "auto" }}><i className="dot" />{statusTxt}</span>
      </div>
      <div className="pl-mini-row">
        {stages.map((st, i) => {
          const cls = i < tgtIdx ? "done" : i === tgtIdx ? (done ? "done" : "live") : "";
          const role = i === 0 ? " · " + t("role.src") : i === tgtIdx ? " · " + t("role.tgt") : i === stages.length - 1 ? " · " + t("role.rel") : "";
          return (
            <React.Fragment key={st.code + i}>
              {i > 0 && <Cx />}
              <div className={"pl-mini " + cls}>
                <span className="code">{st.code}{role}</span>
                <span className="nm">{st.inst}</span>
              </div>
            </React.Fragment>
          );
        })}
      </div>
      <div>
        {jobs.map((j, i) => {
          const cls = j.status === "completed" ? "done" : j.status === "in_progress" ? "run" : "";
          return (
            <div className={"js-li " + cls} key={i}>
              <i className="js-bar" />
              <span>{j.name}</span>
              {j.duration && <span className="js-dur">{j.duration}</span>}
            </div>
          );
        })}
      </div>
      {done && (
        <div style={{ display: "flex", alignItems: "center", gap: 14, marginTop: 18 }}>
          <span className="success-burst" ref={burstRef}><svg className="ic"><use href="#ic-check" /></svg></span>
          <span style={{ fontWeight: 700, color: "var(--ok)" }}>{doneText}</span>
          <span className="tiny muted">{doneSub}</span>
        </div>
      )}
    </div>
  );
}
